import React from "react"
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { EntityTypeFilter } from "../supportEntitiesTypes"
import { iterateStringEnum } from "../../../../../lib/enums"

export function SelectEntityType({
    entityType,
    setEntityType,
}: {
    entityType: EntityTypeFilter
    setEntityType: React.Dispatch<React.SetStateAction<EntityTypeFilter>>
}) {
    return (
        <FormControl sx={{ minWidth: "15rem" }}>
            <LocalizedStrict id="support-entity-table-entity-type-label">
                <InputLabel id="support-entity-type-select-label">Entity Type</InputLabel>
            </LocalizedStrict>
            <Select
                labelId="support-entity-type-select-label"
                id="support-entity-type-select"
                value={entityType}
                label="Entity Type"
                onChange={(e) => setEntityType(e.target.value as EntityTypeFilter)}
            >
                {[...iterateStringEnum(EntityTypeFilter)].map((value) => (
                    <MenuItem key={value} value={value}>
                        <LocalizedEnum base="support-entity-table-entity-type-select-item" enumValue={value}>
                            <span>{value}</span>
                        </LocalizedEnum>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}
